export default __webpack_public_path__ + "static/media/waitlist-delete.c3254b75.svg";